/**
 * Constantes centralizadas de la aplicación
 * Todas las constantes reutilizables deben estar aquí
 */

// ============================================================================
// MESES
// ============================================================================
export const MONTHS = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" }
];

// ============================================================================
// DÍAS DEL MES
// ============================================================================
export const DAYS_OF_MONTH = Array.from({ length: 31 }, (_, i) => i + 1);

// ============================================================================
// OPCIONES DE RECORDATORIO
// ============================================================================
export const REMIND_OPTIONS = [0, 1, 2, 3, 5, 7];

// ============================================================================
// COLORES PARA GRÁFICOS Y CATEGORÍAS
// ============================================================================
export const CHART_COLORS = [
  "#8b5cf6", // purple
  "#6366f1", // indigo
  "#ec4899", // pink
  "#14b8a6", // teal
  "#f59e0b", // amber
  "#ef4444"  // red
];

export const CATEGORY_GRADIENT_COLORS = [
  "from-purple-500 to-purple-600",
  "from-indigo-500 to-indigo-600",
  "from-pink-500 to-pink-600",
  "from-teal-500 to-teal-600",
  "from-amber-500 to-amber-600",
  "from-rose-500 to-rose-600"
];

// ============================================================================
// ESTADOS
// ============================================================================
export const EXPENSE_STATUS = {
  PENDING: "PENDING",
  PAID: "PAID"
};

export const GOAL_STATUS = {
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED"
};

// ============================================================================
// CATEGORÍAS LEGACY
// ============================================================================
export const LEGACY_CATEGORY_OTHER = "_other";

// ============================================================================
// AÑOS (para selectores)
// ============================================================================
export const getYearsArray = (startYear = 2025, count = 6) => {
  return Array.from({ length: count }, (_, i) => startYear + i);
};

// ============================================================================
// CONFIGURACIÓN DE CACHE
// ============================================================================
export const CACHE_CONFIG = {
  EXCHANGE_RATES_KEY: "controlcash_exchange_rates",
  EXCHANGE_RATES_HOURS: 24
};

// ============================================================================
// VALIDACIONES
// ============================================================================
export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 6,
  MIN_AMOUNT: 0.01
};
